module.exports = __webpack_public_path__ + "static/media/domarutbildning_500.dc58bfef.png";